import Card from './Card';

export default Card;
export { Card };

